export const calcEnoughTx = gasCount => {
  const byte = gasCount * 1_000_000
  const mByte = byte / 1000000
  if (mByte < 1000) return mByte + ' Mb'
  const gByte = mByte / 1000
  if (gByte < 1000) return gByte + ' Gb'
  return gByte / 1000 + ' Tb'
}
